class DZModelLandBase {

  /**
   * 主键
   */
  id = "";

  /**
   * 土地类型：1-农业用地，2-建设用地-
   */
  type = "";

  /**
   * 土地编号-
   */
  number = "";

  /**
   * 信息标题-
   */
  title = "";

  /**
   * 列表图片ID
   */
  listCoverId = "";

  /**
   * 土地大类ID-
   */
  bigType = "";

  /**
   * 土地小类ID-
   */
  smallType = "";

  /**
   * 详细地址ID-
   */
  addressId = "";

  /**
   * 土地面积-
   */
  area = "";

  /**
   * 土地面积单位ID ·
   */
  areaUnit = "";

  /**
   * 流转类型ID
   */
  moverType = "";

  /**
   * 土地价格
   */
  price = "";

  /**
   * 价格单位ID
   */
  priceUnit = "";

  /**
   * 使用年限
   */
  usefulYear = "";

  /**
   * 土地图片ID，多个逗号隔开
   */
  imageIds = "";
  /**
   * 图片列表
   */
  imageList = [];
  /**
   * 土地视频ID
   */
  videoId = "";

  /**
   * 土地权证ID
   */
  landCertificates = "";

  /**
   * 土地描述
   */
  describe = "";

  /**
   * 联系人ID
   */
  contactsId = "";

  /**
   * 标签ID，多个逗号隔开
   */
  label = "";
  labelArr = [];

  /**
   * 是否被代理：0-没有代理，1-已被代理
   */
  isAgent = "";

  /**
   * 发布状态：0-待审核，1-待交易，2-审核未通过，3-暂停，4-已过期，5-已交易
   */
  status = "";




  /**
   * 更新用户ID
   */
  updateBy = "";

  /**
   * 更新时间
   */
  updateTime = "";

  /**
   * 发布用户ID
   */
  createBy = "";

  /**
   * 创建时间
   */
  createTime = "";
}
export default DZModelLandBase
